<p-chart #chart type="bar" [data]="chartData" [options]="chartOptions" class="cleared-uncleared-chart"></p-chart>
